/**
 * StudentJEE — placeholder page for the upcoming JEE prep assistant.
 * Shown to students from class 5 onwards.
 */
import StudentLayout from "@/components/StudentLayout";
import { Rocket, Sparkles, Atom, Calculator, FlaskConical, Clock } from "lucide-react";

export default function StudentJEE() {
  return (
    <StudentLayout>
      <div className="max-w-3xl mx-auto" data-testid="student-jee-page">
        <div className="mb-6">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-2">Compete · Prepare</div>
          <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100" style={{ fontFamily: "Outfit" }}>
            <Rocket className="inline h-7 w-7 text-fuchsia-500 mr-2 -mt-1" />
            JEE Preparation Hub
          </h1>
          <p className="text-slate-500 mt-1">
            Start early. An AI-guided JEE foundation track — concept builders, daily challenges and adaptive quizzes — just for you.
          </p>
        </div>

        <div className="relative overflow-hidden rounded-3xl border border-fuchsia-200/40 dark:border-fuchsia-700/30 bg-gradient-to-br from-fuchsia-50 via-violet-50 to-indigo-50 dark:from-fuchsia-950/40 dark:via-violet-950/40 dark:to-indigo-950/40 p-8 sm:p-12 text-center">
          <Sparkles className="absolute top-4 right-6 h-5 w-5 text-fuchsia-400/60 animate-pulse" />
          <Sparkles className="absolute bottom-6 left-8 h-4 w-4 text-indigo-400/60 animate-pulse [animation-delay:300ms]" />

          <div className="inline-flex items-center justify-center h-20 w-20 rounded-3xl bg-white dark:bg-slate-800 shadow-lg mb-5 animate-[pulse_3s_ease-in-out_infinite]">
            <Rocket className="h-10 w-10 text-fuchsia-500" />
          </div>

          <div className="text-[10px] uppercase tracking-[0.3em] text-fuchsia-600 dark:text-fuchsia-300 font-semibold inline-flex items-center gap-1.5 mb-2">
            <Clock className="h-3 w-3" /> Coming soon
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-slate-100" style={{ fontFamily: "Outfit" }}>
            JEE Preparation assistant coming soon!
          </h2>
          <p className="text-slate-500 dark:text-slate-400 mt-2 max-w-md mx-auto">
            Build a strong foundation in Physics, Chemistry and Mathematics from the early years. Get personalised challenges, friendly explanations and daily 5-minute drills.
          </p>

          <div className="mt-8 grid sm:grid-cols-3 gap-3 max-w-2xl mx-auto text-left">
            <FeatureChip icon={Calculator} title="Maths Foundation" copy="Concepts that scale to JEE-level." />
            <FeatureChip icon={FlaskConical} title="Chemistry Lab" copy="Visual, hands-on experiments." />
            <FeatureChip icon={Atom} title="Physics Playground" copy="Learn through real-world stories." />
          </div>
        </div>
      </div>
    </StudentLayout>
  );
}

function FeatureChip({ icon: Icon, title, copy }) {
  return (
    <div className="rounded-2xl bg-white/70 dark:bg-slate-800/60 border border-slate-200/70 dark:border-slate-700/70 p-3">
      <Icon className="h-4 w-4 text-fuchsia-500 mb-1.5" />
      <div className="text-sm font-semibold text-slate-800 dark:text-slate-100">{title}</div>
      <div className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{copy}</div>
    </div>
  );
}
